///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2023 - 2023
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import messages from "../../../helpers/messages";

export const DATRateViewButton = ({ onClick, className }) => {
  return (
    <button
      className={`tertiary-button pl-16 pr-16 h-32 ${className}`}
      onClick={onClick}
      data-testid="datRateViewButton"
      id="dat-rateview-button"
    >
      {messages.viewDATRateView.defaultMessage}
    </button>
  );
};
